import { Component } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AppProvider, useApp } from "@/context/AppContext";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Projects from "@/pages/Projects";
import MasterData from "@/pages/MasterData";
import SPK from "@/pages/SPK";
import DeliveryList from "@/pages/DeliveryList";
import ProjectDeliveryList from "@/pages/ProjectDeliveryList";
import Barcode from "@/pages/Barcode";
import QC from "@/pages/QC";
import STB from "@/pages/STB";
import StbProgress from "@/pages/StbProgress";
import LaporanHarian from "@/pages/LaporanHarian";
import MaterialControl from "@/pages/MaterialControl";
import Laporan from "@/pages/Laporan";
import Tagihan from "@/pages/Tagihan";
import MonitoringProyek from "@/pages/MonitoringProyek";
import MonitoringVendor from "@/pages/MonitoringVendor";
import MonitoringArea from "@/pages/MonitoringArea";
import BarcodeRiwayat from "@/pages/BarcodeRiwayat";
import Users from "@/pages/Users";
import Audit from "@/pages/Audit";
import Settings from "@/pages/Settings";
import { LogoMark } from "@/components/Logo";

class ErrorBoundary extends Component {
  constructor(props) { super(props); this.state = { err: null }; }
  static getDerivedStateFromError(e) { return { err: e }; }
  render() {
    if (this.state.err) {
      return (
        <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-[#07090E] text-slate-300">
          <p className="text-sm">Terjadi kesalahan tampilan / 页面出现错误</p>
          <button onClick={() => { this.setState({ err: null }); window.location.href = "/"; }}
            className="rounded bg-sky-600 px-4 py-2 text-sm text-white hover:bg-sky-500">Muat Ulang</button>
        </div>
      );
    }
    return this.props.children;
  }
}

const Splash = () => (
  <div className="flex min-h-screen items-center justify-center bg-[#07090E]">
    <div className="animate-pulse"><LogoMark size={56} /></div>
  </div>
);

function Shell() {
  const { user, booting } = useApp();
  if (booting) return <Splash />;
  if (!user) return <Login />;
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/master-data" element={<MasterData />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/spk" element={<SPK />} />
        <Route path="/delivery-list" element={<DeliveryList />} />
        <Route path="/delivery-list-proyek" element={<ProjectDeliveryList />} />
        <Route path="/barcode" element={<Barcode />} />
        <Route path="/qc" element={<QC />} />
        <Route path="/stb" element={<STB />} />
        <Route path="/stb-riwayat" element={<StbProgress />} />
        <Route path="/laporan-harian" element={<LaporanHarian />} />
        <Route path="/material-control" element={<MaterialControl />} />
        <Route path="/laporan" element={<Laporan />} />
        <Route path="/tagihan" element={<Tagihan />} />
        <Route path="/monitoring-proyek" element={<MonitoringProyek />} />
        <Route path="/monitoring-vendor" element={<MonitoringVendor />} />
        <Route path="/monitoring-area" element={<MonitoringArea />} />
        <Route path="/barcode-riwayat" element={<BarcodeRiwayat />} />
        <Route path="/users" element={<Users />} />
        <Route path="/audit" element={<Audit />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </Layout>
  );
}

export default function App() {
  return (
    <AppProvider>
      <ErrorBoundary>
        <BrowserRouter>
          <Shell />
          <Toaster richColors position="top-right" theme="dark" />
        </BrowserRouter>
      </ErrorBoundary>
    </AppProvider>
  );
}